// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"10ae2d43","267":"10ae2d43","490":"fdd7ce48","785":"fdd7ce48"}[chunkId] + ".chunk.css";
};